import API from "../utils/api";

// GOD-TASK-197 Tags Automation (Phase 2). The API layer resolves with the response body.

export const getWorkflowsApi = (params) => API.get('tags-automation/workflows', {params});
export const getWorkflowApi = (id) => API.get(`tags-automation/workflows/${id}`);
export const createWorkflowApi = (data) => API.post('tags-automation/workflows', data);
export const updateWorkflowApi = (id, data) => API.put(`tags-automation/workflows/${id}`, data);
export const deleteWorkflowApi = (id, action) => API.delete(`tags-automation/workflows/${id}`, {params: {action}});
export const pauseWorkflowApi = (id, action) => API.post(`tags-automation/workflows/${id}/pause`, {action});
export const resumeWorkflowApi = (id) => API.post(`tags-automation/workflows/${id}/resume`);
export const duplicateWorkflowApi = (id) => API.post(`tags-automation/workflows/${id}/duplicate`);
export const runWorkflowApi = (id) => API.post(`tags-automation/workflows/${id}/run`);
export const runAllWorkflowsApi = () => API.post('tags-automation/workflows/run-all');
export const testWorkflowApi = (id, productId) => API.get(`tags-automation/workflows/${id}/test`, {params: {product_id: productId}});

export const getWorkflowFieldsApi = () => API.get('tags-automation/workflows/fields');
export const getWorkflowSummaryApi = () => API.get('tags-automation/workflows/summary');
export const getCreatedByUsersApi = () => API.get('tags-automation/workflows/created-by-users');
export const searchWorkflowProductsApi = (q) => API.get('tags-automation/workflows/products', {params: {q}});
// utils/api cancels an in-flight request when another goes to the same URL; the form and the
// condition picker can start previews together, so each start gets its own URL.
let previewSeq = 0;
export const startWorkflowPreviewApi = (definition) => API.post(`tags-automation/workflows/preview?n=${++previewSeq}`, definition);
export const getWorkflowPreviewApi = (token) => API.get(`tags-automation/workflows/preview/${token}`);

export const getActivityLogApi = (params) => API.get('tags-automation/activity-log', {params});
export const getActivityLogOptionsApi = () => API.get('tags-automation/activity-log/options');
export const exportActivityLogApi = (params) => API.get('tags-automation/activity-log/export', {params, responseType: 'blob'});
